(() => {
'use strict';
const home=document.querySelector('.oens-home-20261002');
if(!home)return;
const english=home.dataset.homeLocale==='en';
const tr=(da,en)=>english?en:da;
const videoDialog = document.getElementById('video-dialog');
const video = videoDialog.querySelector('video');
const heroVideo = home.querySelector('.hero-video');
const heroMotion = home.querySelector('.hero-motion');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
let heroPausedByUser = reducedMotion.matches;
let heroVisible = true;
heroVideo.muted = true;
heroVideo.defaultMuted = true;
const heroSubtitles = home.querySelector('.hero-subtitles');
const heroCaptionTrack = heroVideo.textTracks[0];
heroCaptionTrack.mode = 'hidden';
function syncHeroCaptions() {
  const text = Array.from(heroCaptionTrack.activeCues || []).map(cue => cue.text).join(' ');
  heroSubtitles.querySelector('span').textContent = text;
  heroSubtitles.hidden = !text;
}
heroCaptionTrack.addEventListener('cuechange', syncHeroCaptions);
heroVideo.addEventListener('loadeddata', syncHeroCaptions);
heroVideo.addEventListener('seeked', syncHeroCaptions);

function syncHeroPlayback() {
  if (heroPausedByUser || !heroVisible || document.hidden || videoDialog.open) {
    heroVideo.pause();
  } else {
    heroVideo.play().catch(() => {});
  }
}
function syncHeroButton() {
  const paused = heroVideo.paused;
  heroMotion.setAttribute('aria-label', paused ? tr("Afspil baggrundsvideoen","Play background video") : tr("Sæt baggrundsvideoen på pause","Pause background video"));
  heroMotion.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
}
heroVideo.addEventListener('play', syncHeroButton);
heroVideo.addEventListener('pause', syncHeroButton);
heroMotion.addEventListener('click', () => {
  heroPausedByUser = !heroVideo.paused;
  syncHeroPlayback();
});
new IntersectionObserver(entries => {
  heroVisible = entries[0].isIntersecting;
  syncHeroPlayback();
}, { threshold: 0.05 }).observe(heroVideo);
document.addEventListener('visibilitychange', syncHeroPlayback);
reducedMotion.addEventListener('change', event => {
  heroPausedByUser = event.matches;
  syncHeroPlayback();
});
syncHeroPlayback();
syncHeroButton();
home.querySelector('.video-trigger').addEventListener('click', () => {
  videoDialog.showModal();
  heroVideo.pause();
  video.currentTime = heroVideo.currentTime;
  video.play().catch(() => {});
});
videoDialog.addEventListener('close', () => {
  video.pause();
  syncHeroPlayback();
});

const reviewTrack = document.getElementById('review-track');
const reviewCards = [...reviewTrack.querySelectorAll('.review-card')];
const reviewSection = home.querySelector('.reviews');
const reviewToggle = home.querySelector('.review-toggle');
const reviewPosition = home.querySelector('.review-position');
const reviewAnnouncement = home.querySelector('.review-announcement');
let reviewPausedByUser = reducedMotion.matches;
let reviewVisible = false;
let reviewHovered = false;
let reviewTimer;
function reviewGeometry() {
  const gap = parseFloat(getComputedStyle(reviewTrack).columnGap) || 0;
  const step = reviewCards[0].getBoundingClientRect().width + gap;
  const maxScroll = reviewTrack.scrollWidth - reviewTrack.clientWidth;
  const index = Math.min(reviewCards.length - 1, Math.round(reviewTrack.scrollLeft / step));
  const visible = Math.max(1, Math.floor((reviewTrack.clientWidth + gap) / step));
  return { step, maxScroll, index, visible };
}
function updateReviewPosition(announce = false) {
  const { index, visible } = reviewGeometry();
  const last = Math.min(reviewCards.length, index + visible);
  reviewPosition.textContent = `${index + 1}${visible > 1 ? tr(' til ', ' to ') + last : ''} / ${reviewCards.length}`;
  if (announce) reviewAnnouncement.textContent = `${tr('Anmeldelse', 'Review')} ${index + 1} ${tr('af', 'of')} ${reviewCards.length}`;
}
function advanceReviews(direction, announce = false) {
  const { step, maxScroll, index } = reviewGeometry();
  let target = (index + direction) * step;
  if (direction > 0 && reviewTrack.scrollLeft >= maxScroll - 3) target = 0;
  if (direction < 0 && reviewTrack.scrollLeft < 3) target = maxScroll;
  reviewTrack.scrollTo({ left: Math.max(0, Math.min(maxScroll, target)), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  if (announce) window.setTimeout(() => updateReviewPosition(true), reducedMotion.matches ? 0 : 650);
}
function scheduleReviews() {
  window.clearInterval(reviewTimer);
  const focused = reviewTrack.contains(document.activeElement);
  if (!reviewPausedByUser && reviewVisible && !reviewHovered && !focused && !document.hidden) {
    reviewTimer = window.setInterval(() => advanceReviews(1), 6000);
  }
  reviewToggle.firstChild.textContent = reviewPausedByUser ? '▶ ' : 'Ⅱ ';
  reviewToggle.querySelector('span').textContent = reviewPausedByUser ? tr("Afspil","Play") : 'Pause';
  reviewToggle.setAttribute('aria-label', reviewPausedByUser ? tr("Start automatisk karrusel","Start automatic carousel") : tr("Sæt karrusellen på pause","Pause carousel"));
}
function navigateReviews(direction) {
  advanceReviews(direction, true);
  reviewPausedByUser = reducedMotion.matches;
  scheduleReviews();
}
home.querySelector('.review-prev').addEventListener('click', () => navigateReviews(-1));
home.querySelector('.review-next').addEventListener('click', () => navigateReviews(1));
reviewToggle.addEventListener('click', () => {
  reviewPausedByUser = !reviewPausedByUser;
  // Et aktivt valg af afspilning skal kunne starte karrusellen fra knappen.
  if (!reviewPausedByUser) reviewToggle.blur();
  scheduleReviews();
});
reviewTrack.addEventListener('keydown', event => {
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
    event.preventDefault();
    advanceReviews(event.key === 'ArrowLeft' ? -1 : 1, true);
  }
});
reviewTrack.addEventListener('scroll', () => updateReviewPosition(), { passive: true });
reviewTrack.addEventListener('pointerdown', event => {
  if (event.pointerType === 'touch') {
    reviewPausedByUser = true;
    scheduleReviews();
  }
}, { passive: true });
reviewTrack.addEventListener('mouseenter', () => { reviewHovered = true; scheduleReviews(); });
reviewTrack.addEventListener('mouseleave', () => { reviewHovered = false; scheduleReviews(); });
reviewSection.addEventListener('focusin', scheduleReviews);
reviewSection.addEventListener('focusout', () => window.setTimeout(scheduleReviews, 0));
new IntersectionObserver(entries => {
  reviewVisible = entries[0].isIntersecting;
  scheduleReviews();
}, { threshold: 0.2 }).observe(reviewTrack);
document.addEventListener('visibilitychange', scheduleReviews);
window.addEventListener('resize', () => updateReviewPosition());
reducedMotion.addEventListener('change', event => {
  reviewPausedByUser = event.matches;
  scheduleReviews();
});
updateReviewPosition();
scheduleReviews();

const galleryDialog = document.getElementById('gallery-dialog');
home.querySelectorAll('[data-gallery]').forEach(button => {
  button.addEventListener('click', () => {
    const source = button.querySelector('img');
    const image = galleryDialog.querySelector('img');
    image.src = source.src;
    image.alt = source.alt;
    galleryDialog.querySelector('p').textContent = source.alt;
    galleryDialog.showModal();
  });
});
home.querySelectorAll('.media-dialog').forEach(dialog => {
  dialog.querySelector('.dialog-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
});

(() => {
  'use strict';

  function enhanceContactPhoto() {
    const gallery = home.querySelector('.contact-photo');
    const original = gallery?.querySelector('img');
    if (!original || gallery.dataset.contactGallery) return;

    const references = [...home.querySelectorAll('.gallery-grid img')];
    const floor = home.querySelector('.service-card img[src*="traegulv-slebet"]');
    const kitchen = references.find(image => image.src.includes('bordplade-efter'));
    const candidates = [original, floor, kitchen, ...references].filter(Boolean);
    const seen = new Set();
    const items = candidates.filter(image => {
      if (seen.has(image.src)) return false;
      seen.add(image.src);
      return true;
    }).slice(0, 6).map(image => ({
      src: image === floor ? new URL('https://haandvaerkercentral.dk/cdn/shop/files/traegulv-slebet-og-lakeret-lejlighed.jpg?v=1786275163&width=1800', document.baseURI).href : image.src,
      alt: image.alt
    }));
    if (items.length < 2) return;

    gallery.dataset.contactGallery = 'ready';
    gallery.classList.add('contact-gallery');
    gallery.setAttribute('role', 'region');
    gallery.setAttribute('aria-roledescription', tr("karrusel","carousel"));
    gallery.setAttribute('aria-label', tr("Billeder af vores arbejde","Photos of our work"));

    const open = document.createElement('button');
    open.type = 'button';
    open.className = 'contact-gallery__open';
    original.replaceWith(open);
    open.append(original);
    const images = items.map((item, index) => {
      const image = index === 0 ? original : document.createElement('img');
      image.src = item.src;
      image.alt = item.alt;
      image.draggable = false;
      image.decoding = 'async';
      image.loading = index < 2 ? 'eager' : 'lazy';
      image.setAttribute('aria-hidden', 'true');
      image.classList.add('contact-gallery__image');
      image.classList.toggle('is-current', index === 0);
      if (index !== 0) open.append(image);
      return image;
    });

    const controls = document.createElement('div');
    controls.className = 'contact-gallery__controls';
    controls.innerHTML = '<span class="contact-gallery__counter" aria-hidden="true"></span>' +
      '<div class="contact-gallery__buttons">' +
      '<button class="contact-gallery__control contact-gallery__pause" type="button"></button>' +
      '<button class="contact-gallery__control contact-gallery__previous" type="button" aria-label="Forrige billede"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button>' +
      '<button class="contact-gallery__control contact-gallery__next" type="button" aria-label="Næste billede"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>' +
      '</div>';
    controls.querySelector('.contact-gallery__previous').setAttribute('aria-label', tr('Forrige billede','Previous photo'));
    controls.querySelector('.contact-gallery__next').setAttribute('aria-label', tr('Næste billede','Next photo'));
    gallery.append(controls);
    const status = document.createElement('span');
    status.className = 'contact-gallery__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    gallery.append(status);

    const count = controls.querySelector('.contact-gallery__counter');
    const pause = controls.querySelector('.contact-gallery__pause');
    const dialog = document.getElementById('gallery-dialog');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let userPaused = reducedMotion.matches;
    let hovering = false;
    let focused = false;
    let allowFocusedPlayback = false;
    let visible = false;
    let dialogOpen = false;
    let timer = null;
    let pointerStart = null;
    let suppressClick = false;

    function updateControl() {
      pause.setAttribute('aria-pressed', String(userPaused));
      pause.setAttribute('aria-label', userPaused ? tr("Start automatisk billedskift","Start automatic slideshow") : tr("Sæt automatisk billedskift på pause","Pause slideshow"));
      pause.title = userPaused ? tr("Start billedskift","Start slideshow") : 'Pause';
      pause.innerHTML = userPaused
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="contact-gallery__play" d="m9 6 9 6-9 6Z"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6v12M15 6v12"/></svg>';
    }

    function schedule() {
      window.clearTimeout(timer);
      timer = null;
      const running = !userPaused && !hovering && (!focused || allowFocusedPlayback) && visible && !document.hidden && !dialogOpen;
      gallery.dataset.autoplay = running ? 'running' : 'paused';
      if (running) timer = window.setTimeout(() => show(current + 1), 5500);
    }

    function show(index, announce = false) {
      current = (index + items.length) % items.length;
      images.forEach((image, imageIndex) => image.classList.toggle('is-current', imageIndex === current));
      count.textContent = `${current + 1} / ${items.length}`;
      gallery.dataset.slide = String(current + 1);
      open.setAttribute('aria-label', `${tr('Åbn billede','Open photo')} ${current + 1} ${tr('af','of')} ${items.length}: ${items[current].alt}`);
      if (announce) status.textContent = `${tr('Billede','Photo')} ${current + 1} ${tr('af','of')} ${items.length}. ${items[current].alt}`;
      schedule();
    }

    controls.querySelector('.contact-gallery__previous').addEventListener('click', () => show(current - 1, true));
    controls.querySelector('.contact-gallery__next').addEventListener('click', () => show(current + 1, true));
    pause.addEventListener('click', () => {
      userPaused = !userPaused;
      // An explicit start takes effect while the start button keeps focus.
      allowFocusedPlayback = !userPaused;
      updateControl();
      schedule();
    });
    gallery.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    open.addEventListener('pointerenter', event => {
      if (event.pointerType !== 'mouse') return;
      hovering = true;
      schedule();
    });
    open.addEventListener('pointerleave', () => {
      hovering = false;
      schedule();
    });
    gallery.addEventListener('focusin', () => {
      focused = true;
      allowFocusedPlayback = false;
      schedule();
    });
    gallery.addEventListener('focusout', () => {
      window.setTimeout(() => {
        focused = gallery.contains(document.activeElement);
        if (!focused) allowFocusedPlayback = false;
        schedule();
      }, 0);
    });
    open.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' || !event.isPrimary) return;
      pointerStart = { x: event.clientX, y: event.clientY };
      open.setPointerCapture(event.pointerId);
    });
    open.addEventListener('pointerup', event => {
      if (!pointerStart) return;
      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      suppressClick = true;
      show(current + (dx < 0 ? 1 : -1), true);
      window.setTimeout(() => { suppressClick = false; }, 500);
    });
    open.addEventListener('pointercancel', () => { pointerStart = null; });
    open.addEventListener('dragstart', event => event.preventDefault());
    open.addEventListener('click', event => {
      if (suppressClick) {
        event.preventDefault();
        suppressClick = false;
        return;
      }
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('img');
      const caption = dialog.querySelector('p');
      if (!image) return;
      image.src = items[current].src;
      image.alt = items[current].alt;
      if (caption) caption.textContent = items[current].alt;
      dialogOpen = true;
      schedule();
      if (!dialog.open) dialog.showModal();
    });
    dialog?.addEventListener('close', () => {
      dialogOpen = false;
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', event => {
      if (event.matches) userPaused = true;
      updateControl();
      schedule();
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
      schedule();
    }, { threshold: [0, 0.25] });
    observer.observe(gallery);
    updateControl();
    show(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceContactPhoto, { once: true });
  else enhanceContactPhoto();
})();

(() => {
  'use strict';

  function enhanceServiceHeading() {
    const heading = document.getElementById('services-title');
    if (!heading || heading.dataset.serviceCycle) return;
    const words = english ? ['balcony sanding','floor sanding','worktop sanding','algae treatment','patio cleaning','painting','move-out packages'] : ['altanslibning', 'gulvslibning', 'køkkenslibning', 'algebehandling', 'fliserens', 'maling', 'udflytningspakker'];
    const accessibleTitle = heading.textContent.trim();
    const row = document.createElement('div');
    row.className = 'service-cycle-row';
    heading.replaceWith(row);
    row.append(heading);
    heading.classList.add('service-cycle-title');
    heading.dataset.serviceCycle = 'ready';
    heading.replaceChildren();

    const accessible = document.createElement('span');
    accessible.className = 'service-cycle-accessible';
    accessible.textContent = accessibleTitle;
    const visual = document.createElement('span');
    visual.className = 'service-cycle-visual';
    visual.setAttribute('aria-hidden', 'true');
    const prefix = document.createElement('span');
    prefix.className = 'service-cycle-prefix';
    prefix.textContent = tr('Vi laver','We do');
    const slot = document.createElement('span');
    slot.className = 'service-cycle-slot';
    words.forEach(word => {
      const measure = document.createElement('span');
      measure.className = 'service-cycle-measure';
      measure.textContent = word;
      slot.append(measure);
    });
    const value = document.createElement('span');
    value.className = 'service-cycle-value';
    const typed = document.createElement('span');
    typed.className = 'service-cycle-text';
    const caret = document.createElement('span');
    caret.className = 'service-cycle-caret';
    value.append(typed, caret);
    slot.append(value);
    visual.append(prefix, document.createTextNode(' '), slot);
    heading.append(accessible, visual);

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let wordIndex = 0;
    let length = words[0].length;
    let phase = 'hold';
    let remaining = 2600;
    let dueAt = 0;
    let timer = null;
    let inView = false;

    function paint() {
      typed.textContent = words[wordIndex].slice(0, length);
      heading.dataset.word = words[wordIndex];
      heading.dataset.phase = phase;
    }

    function stopTimer() {
      if (timer !== null) {
        remaining = Math.max(0, dueAt - performance.now());
        window.clearTimeout(timer);
        timer = null;
      }
    }

    function synchronize() {
      stopTimer();
      const running = inView && !document.hidden && !reducedMotion.matches;
      heading.dataset.running = String(running);
      if (running) {
        dueAt = performance.now() + remaining;
        timer = window.setTimeout(tick, remaining);
      }
    }

    function tick() {
      timer = null;
      if (phase === 'hold' || phase === 'deleting') {
        length = Math.max(0, length - 1);
        phase = length === 0 ? 'gap' : 'deleting';
        remaining = length === 0 ? 420 : 22;
      } else if (phase === 'gap') {
        wordIndex = (wordIndex + 1) % words.length;
        phase = 'typing';
        remaining = 45;
      } else {
        length += 1;
        phase = length === words[wordIndex].length ? 'hold' : 'typing';
        remaining = phase === 'hold' ? 2600 : 45;
      }
      paint();
      synchronize();
    }

    document.addEventListener('visibilitychange', synchronize);
    reducedMotion.addEventListener('change', () => {
      stopTimer();
      if (reducedMotion.matches) {
        wordIndex = 0;
        length = words[0].length;
        phase = 'hold';
        remaining = 2600;
        paint();
      }
      synchronize();
    });
    const observer = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
      synchronize();
    }, { threshold: [0, 0.5] });
    observer.observe(heading);
    paint();
    synchronize();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhanceServiceHeading, { once: true });
  else enhanceServiceHeading();
})();

})();
'use strict';

(() => {
  const root = document.querySelector('.oens-home-20261002');
  if (!root) return;
  const english = document.documentElement.lang.toLowerCase().startsWith('en');
  document.documentElement.classList.add('oens-home-privacy');

  // Keep Shopify's native banner and its existing GTM consent bridge as owners.
  // No consent is saved here, and no tracking or analytics events are emitted.
  const visible = element => !!element && element.getClientRects().length > 0 &&
    getComputedStyle(element).visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true';
  let privacyFrame = 0;
  function updatePrivacyVisibility() {
    privacyFrame = 0;
    document.body.classList.toggle('cookie-banner-open', visible(document.getElementById('shopify-pc__banner')));
    document.body.classList.toggle('cookie-settings-open', visible(document.getElementById('shopify-pc__prefs')));
  }
  function queuePrivacyUpdate() {
    if (!privacyFrame) privacyFrame = requestAnimationFrame(updatePrivacyVisibility);
  }
  const privacyObserver = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' ||
      record.target.closest?.('[id^="shopify-pc__"]'))) queuePrivacyUpdate();
  });
  privacyObserver.observe(document.body, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['style', 'hidden', 'aria-hidden', 'class']
  });
  document.addEventListener('visitorConsentCollected', queuePrivacyUpdate);
  updatePrivacyVisibility();

  // The footer source stays unchanged. Add the settings link when Shopify is ready.
  let privacyAttempts = 0;
  function attachPrivacySettings() {
    const api = window.privacyBanner;
    const policy = document.querySelector('.oens-footer a[href$="/policies/privacy-policy"]');
    if (!api || typeof api.showPreferences !== 'function' || !policy) {
      if (++privacyAttempts < 60) setTimeout(attachPrivacySettings, 500);
      return;
    }
    if (document.getElementById('oens-native-cookie-settings')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'oens-native-cookie-settings';
    button.className = 'oens-native-cookie-settings';
    button.textContent = english ? 'Cookie settings' : 'Cookieindstillinger';
    button.setAttribute('aria-haspopup', 'dialog');
    button.addEventListener('click', () => {
      Promise.resolve(api.showPreferences()).then(queuePrivacyUpdate).catch(() => {
        // The existing policy remains an accessible fallback if Shopify fails.
        location.assign(policy.href);
      });
    });
    const item = document.createElement('li');
    item.append(button);
    policy.closest('li')?.after(item);
  }
  attachPrivacySettings();

  const panel = document.getElementById('follow-contact');
  const home = document.getElementById('follow-contact-home');
  const dialog = document.getElementById('follow-dialog');
  const dock = document.getElementById('follow-dock');
  const mainForm = document.getElementById('offer-form');
  const followForm = document.getElementById('follow-form');
  if (!panel || !home || !dialog || !dock || !mainForm || !followForm) return;
  const openButton = dock.querySelector('.follow-open');
  const closeButton = panel.querySelector('.follow-close');
  const hero = root.querySelector('.hero');
  // The header container includes the collapsed mobile menu. Measure its bar.
  const header = document.querySelector('#glpPfnav .glp-pfnav__bar') || document.querySelector('.site-header');
  const footer = document.querySelector('.oens-footer, .site-footer');
  const menu = document.querySelector('.glp-pfnav__burger, .menu-toggle');
  const fields = new Set(['contact[name]', 'contact[email]', 'contact[phone]', 'contact[zip]', 'contact[body]']);
  let queued = false;

  // Only the five visible fields are shared in memory. Shopify's hidden fields,
  // captcha and native submission are never copied or intercepted.
  [mainForm, followForm].forEach(source => {
    const target = source === mainForm ? followForm : mainForm;
    const syncField = event => {
      const field = event.target;
      if (!fields.has(field.name)) return;
      const other = target.elements.namedItem(field.name);
      if (other) other.value = field.value;
    };
    source.addEventListener('input', syncField);
    source.addEventListener('change', syncField);
  });
  fields.forEach(name => {
    const source = mainForm.elements.namedItem(name);
    const target = followForm.elements.namedItem(name);
    if (source && target && source.value) target.value = source.value;
  });

  function updateVisibility() {
    queued = false;
    if (dialog.open) {
      panel.hidden = false;
      dock.hidden = true;
      return;
    }
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    const rect = mainForm.getBoundingClientRect();
    const passedHero = hero && hero.getBoundingClientRect().bottom <= headerBottom + 16;
    const mainVisible = rect.top < innerHeight - 40 && rect.bottom > headerBottom + 40;
    const footerVisible = footer && footer.getBoundingClientRect().top < innerHeight - 40;
    const menuOpen = menu && menu.getAttribute('aria-expanded') === 'true';
    const otherDialog = document.querySelector('dialog[open]:not(#follow-dialog)');
    dock.classList.toggle('is-muted', !!(mainVisible || footerVisible));
    panel.hidden = true;
    dock.hidden = !passedHero || !!menuOpen || !!otherDialog;
    openButton.setAttribute('aria-expanded', 'false');
  }
  function queueUpdate() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(updateVisibility);
    }
  }
  openButton.addEventListener('click', () => {
    panel.hidden = false;
    dialog.append(panel);
    dialog.showModal();
    document.body.classList.add('contact-dialog-open');
    openButton.setAttribute('aria-expanded', 'true');
    document.getElementById('follow-title').focus({ preventScroll: true });
    dock.hidden = true;
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    home.append(panel);
    document.body.classList.remove('contact-dialog-open');
    updateVisibility();
    if (!dock.hidden) openButton.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  addEventListener('scroll', queueUpdate, { passive: true });
  addEventListener('resize', queueUpdate, { passive: true });
  const observer = new MutationObserver(queueUpdate);
  if (menu) observer.observe(menu, { attributes: true, attributeFilter: ['aria-expanded'] });
  document.querySelectorAll('dialog').forEach(item => observer.observe(item, {
    attributes: true, attributeFilter: ['open']
  }));
  if (document.fonts) document.fonts.ready.then(queueUpdate);
  updateVisibility();
})();
